import React, { Component } from 'react';
import apiDown from '../assets/Images/api-down.png';

class RequestExpired extends Component {

  render() {
    return (
      <div className="main-content">
        <div className="ccpa-wrapper">
          <div className="component-section">
            <div className ="max-width-22 position-center margin-center">
              <img src={apiDown} className="margin-bottom-2 position-center" alt="api-down" /> 
              <p className="margin-top-1 font-size-14 text-bold">
                This request has already completed or has timed out. There is nothing else that needs to be done for this request. 
                If you have not got an acknowldgement for this request please create a new request.
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default RequestExpired;
